<template>
  <div>
    <b-card no-body class="card-booking">
    <b-tabs card class="tabs-booking" @input="handleTabChange">
      <b-tab title="発注票" class="tab-title-booking"
             active>
        <div>
          <div class="top-booking">
            <div class="control">
              <b-field>
                <VueJsonToCsv :labels="csvBookingLabels"
                              :json-data="csvBookingJsonData"
                              :csv-title="csvBookingTitle">
                  <b-button class="is-small"
                            icon-left="download"
                            @click="downloadForBooking">
                    Download CSV
                  </b-button>
                </VueJsonToCsv>
              </b-field>
            </div>
          </div>
          <hr style="margin: 0.5rem 0; height: 1px" />
          <ActionBar :checkedItems="checkedItems"
                     @done="actionDone"
                     :tab = "'company'"
                     :isOrders="false" />
          <div v-for="vendor in vendors"
               :key="vendor.id"
               :vendor="vendor">
            <section class="mb-6">
              <div class="columns">
                <div class="column">
                  <h3 class="title is-size-4">{{ vendor.name }}</h3>
                </div>
                <div class="column has-text-right">
                  <router-link :to="{ name: 'booking-form', params: { id: vendor.id, type: tabActive  } }">
                    <b-button size="is-small"
                              type="is-primary"
                              outlined>陸送発注票</b-button>
                  </router-link>
                </div>
              </div>
              <ItemTableList :items="vendor.items"
                             :isBooked="false"
                             ref="list"
                             checkable
                             @onUpdateCheckedItems="onUpdateCheckedItems"
                             @confirmOrder="confirmOrder"
                             @item-click="itemClick" />
            </section>
          </div>
        </div>
      </b-tab>
      <b-tab title="受注票" class="tab-title-booking">
        <div>
          <div class="top-booking">
            <div class="control">
              <b-field>
                <VueJsonToCsv :labels="csvBookingLabels"
                              :json-data="csvBookingJsonData"
                              :csv-title="csvBookingTitle">
                  <b-button class="is-small"
                            icon-left="download"
                            @click="downloadForBooking">
                    Download CSV
                  </b-button>
                </VueJsonToCsv>
              </b-field>
            </div>
          </div>
          <hr style="margin: 0.5rem 0; height: 1px" />
          <ActionBar :checkedItems="checkedItems"
                     @done="actionDone"
                     :isOrders="false" />
          <div v-for="vendor in vendors"
               :key="vendor.id"
               :vendor="vendor">
            <section class="mb-6">
              <div class="columns">
                <div class="column">
                  <h3 class="title is-size-4">{{ vendor.name }}</h3>
                </div>
                <div class="column has-text-right">
                  <router-link :to="{ name: 'booking-form', params: { id: vendor.id, type: tabActive } }">
                    <b-button size="is-small"
                              class="routing-customer"
                              outlined>陸送受注票</b-button>
                  </router-link>
                </div>
              </div>
              <ItemTableList :items="vendor.items"
                             :isBooked="false"
                             ref="list"
                             checkable
                             @onUpdateCheckedItems="onUpdateCheckedItems"
                             @confirmOrder="confirmOrder"
                             @item-click="itemClick" />
            </section>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </b-card>
  </div>
</template>
<style>
.top-booking {
  text-align: right;
}
.card-booking{
  box-shadow: none !important;
}
.tabs-booking{
  display: block !important;
  overflow-x: hidden !important;
  box-shadow: none !important;
}
.tabs-booking a {
  -webkit-box-align: unset !important;
  -ms-flex-align: center !important;
  border-bottom-color: #dbdbdb !important;
  border-bottom-style: hidden !important;
  border-bottom-width: 0 !important;
  color: #7957d5 !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: block !important;
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
  margin-bottom: 0 !important;
  padding: 0 !important;
}
.tabs-booking .card-header{
  background-color:rgba(0,0,0,.1);
  box-shadow: none !important;
  border-left: 1px solid rgba(0,0,0,.1);
  border-top: 1px solid rgba(0,0,0,.1);
}
.tabs-booking .card-header ul{
  border-bottom-color: unset;
  border-bottom-style: unset;
  border-bottom-width: 0;
}
.tabs-booking .card-header ul li a{
  height: 60px;
  display: flex !important;
  align-items: center;
  padding: 10px !important;
  color: black !important;
  font-weight: 600;
} 
.tabs-booking .card-header ul li .active{
  background-color: #ffffff;
  color: #7957d5 !important;
}
.routing-customer{
  color: #ef9016 !important;
  border-color: #ef9016 !important;
  background-color: #ffffff !important;
}
.routing-customer:hover{
  color: #ffffff !important;
  background-color: #ef9016 !important;
}
</style>
<script>
import moment from 'moment';
import { BTabs, BTab } from 'bootstrap-vue';
export default {
  components: {
    ItemTableList: () => import('@/components/ItemTableList.vue'),
    ActionBar: () => import('@/components/ActionBar.vue'),
    VueJsonToCsv: () => import('vue-json-to-csv'),
    BTabs,
    BTab,
  },
  data: () => ({
    checkedItemMap: [],
    checkedItems: [],
    vendors: [],
    criteria: '',
    orderItems: [],
    csvBookingLabels: {},
    csvBookingJsonData: [],
    csvBookingTitle: '',
    listItemBooking: [],
    tabActive: 0
  }),
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.$store.commit('isLoadingApi', true);
      await this.getData();
      this.vendors = this.$store.getters.transportVendorsWithItems;
      this.user = this.$store.state.user;
      this.auctionVendors = this.$store.state.auctionVendors;
      this.$store.commit('isLoadingApi', false);
    },
    getData() {
      this.orderItems = this.$store.getters.incompleteItems;
      this.$store.commit('setOrdersCount', this.orderItems.length);
      if(this.tabActive == 0){
        if (this.$store.getters.transportVendorsWithItems.length > 0) {
          this.filterDate(
            this.$store.getters.transportVendorsWithItems[0].items,
            this.orderItems
          );
        }
      }else{
        if (this.$store.getters.transportVendorsWithCustomer.length > 0) {
          this.filterDate(
            this.$store.getters.transportVendorsWithCustomer[0].items,
            this.orderItems
          );
        }
      }
    },
    filterDate(data, items) {
      let arrayIndex = [];
      let arrayData = [];
      data.map((x) => {
        this.orderItems.map((y, index) => {
          if (x.vinNo == y.vinNo && x.transportFromId == y.transportFromId) {
            arrayIndex.push(index);
          }
        });
      });
      this.orderItems.map((x, index) => {
        let a = arrayIndex.indexOf(index);
        if (a < 0) {
          arrayData.push(x);
        }
      });
      this.orderItems = [...arrayData];
      this.$store.commit('setOrdersCount', this.orderItems.length);
    },
    onUpdateCheckedItems(props) {
      this.checkedItemMap[props.uid] = props.items;
      this.checkedItems = this.checkedItemMap.reduce((r, items) => {
        r.push(...items);
        return r;
      }, []);
    },
    async actionDone() {
      this.$store.commit('isLoadingApi', true);
      await this.$store.dispatch('fetchOrdersAndBookingItems');
      await this.getData();
      if(this.tabActive == 0){
        this.vendors = this.$store.getters.transportVendorsWithItems; 
      }else{
        this.vendors = this.$store.getters.transportVendorsWithCustomer;
      }
      this.$refs.list.forEach((ref) => (ref.$data.checkedItems = []));
      this.checkedItems = [];
      this.$store.commit('isLoadingApi', false);
    },
    cancelOrder(item) {
      this.$buefy.dialog.confirm({
        title: '手配のキャンセル',
        message: '手配をキャンセルしますか？',
        type: 'is-warning',
        cancelText: 'いいえ',
        confirmText: 'はい',
        hasIcon: true,
        onConfirm: async () => {
          item.setTransportStatus('waiting');
          if(this.tabActive == 0){
            this.vendors = this.$store.getters.transportVendorsWithItems;
          }else{
            this.vendors = this.$store.getters.transportVendorsWithCustomer;
          }
          this.$store.dispatch('saveItem', item);
        },
      });
    },
    confirmOrder(item) {
      this.$buefy.dialog.prompt({
        title: '手配完了',
        message:
          'Vin No: ' +
          this.item.VinNo.value +
          '<br>' +
          'Model: ' +
          this.item.Model.value +
          '<br>' +
          'Grade: ' +
          this.item.Grade.value +
          '<br>' +
          'Auction Site: ' +
          this.item.AuctionAreaSatellite.value +
          '<br>' +
          'Yard: ' +
          this.item.YardCompany.value +
          '&emsp;' +
          this.item.YardName.value +
          '&emsp;' +
          '<br>' +
          '陸送会社: ' +
          this.item.TransporterName.value +
          '<br>' +
          '陸送費用: ' +
          this.item.TransportActCost.value +
          '<br>' +
          '<br>' +
          'ヤード搬入予定日を入力してください',
        confirmText: '確定',
        cancelText: 'キャンセル',
        inputAttrs: {
          type: 'date',
          value: moment().format('YYYY-MM-DD'),
        },
        trapFocus: true,
        onConfirm: () => {
          item.setTransportStatus('completed');
          this.$store.dispatch('saveItem', item);
          if(this.tabActive == 0){
            this.vendors = this.$store.getters.transportVendorsWithItems;
          }else{
            this.vendors = this.$store.getters.transportVendorsWithCustomer;
          }
        },
      });
    },
    itemClick(p) {
      this.$store.commit('setItemsInList', p.items);
      this.$router.push({
        name: 'item',
        params: {
          id: p.item.id,
          isBookedItem: false,
          isOrder: false,
        },
      });
    },
    downloadForBooking() {
      this.listItemBooking = [];
      this.vendors.map((vendor) => {
        vendor.items.map((item) => this.listItemBooking.push(item));
      });
      this.csvBookingLabels = {
        orderDate: { title: '受注' },
        vinNo: { title: '車台番号' },
        model: { title: '車種' },
        hasNumberPlate: { title: 'ナンバー' },
        conditionChecked: { title: '状態' },
        transportFrom: { title: '引取先' },
        lotNo: { title: '出品番号' },
        transportTo: { title: '納車先' },
        transportVendorName: { title: '陸送会社' },
        transportActualCost: { title: '陸送費' },
        transportOutFee: { title: '搬出費' },
        transportNumberPlateCutFee: { title: 'カット料' },
        transportTotalActualCost: { title: '費用合計' },
        transportCost: { title: '陸送請求額' },
        transportTotalCost: { title: '請求合計' },
        transportRequestDate: { title: '手配' },
        transportRequestConfirmDate: { title: '手配完了' },
        transportEstimatedArrivalDate: { title: '納車予定' },
      };
      this.csvBookingJsonData = this.listItemBooking.map((item) =>
        Object.assign({}, item, {
          transportFrom: item.transportFromName,
          transportTo: this.transportTo(item),
        })
      );
      this.csvBookingTitle = 'Booking_List';
    },
    transportTo(item) {
      const to = this.$store.getters.yardVendor(item.transportToId);
      return to
        ? to.Company.value + ' ' + item.transportToName
        : item.transportToName;
    },
    handleTabChange(newTab) {
      if(this.tabActive != newTab){
        this.checkedItems = [];
        this.checkedItemMap = [];
      }
      this.tabActive = newTab;
      if(newTab == 0){
        this.vendors = this.$store.getters.transportVendorsWithItems;
      }else{
        this.vendors = this.$store.getters.transportVendorsWithCustomer;
      }
    }
  },
};
</script>
